import React, { Component } from 'react';
import Truncate from 'react-truncate';
import { FaPlusCircle } from 'react-icons/lib/fa';
import { FaMinusCircle } from 'react-icons/lib/fa';

class AssessmentCriteria extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isExpanded: false,
      isTruncated: false
    };
  }

  handleClick = () => {
    const { isExpanded } = this.state;
    
    this.setState({ isExpanded: !isExpanded });
  };

  readMoreButton = (isExpanded) => {
    return (
      <div
        className="assessment-criteria-read-more"
        onClick={this.handleClick}
      >
        { isExpanded ? 
          <FaMinusCircle className="assessment-criteria-read-more-icon" /> :
          <FaPlusCircle className="assessment-criteria-read-more-icon" />
        }
        { isExpanded ? 'Read less' : 'Read more' }
      </div>
    );
  };

  render() {
    const { criteria } = this.props;
    const { isExpanded, isTruncated } = this.state;

    return (
      <div className="assessment-criteria">
        <Truncate
          lines={!isExpanded && 3}
          ellipsis={(
            <span>
              ... 
              {this.readMoreButton(isExpanded)}
            </span>
          )}
        >
          {criteria}
        </Truncate>
        {!isTruncated && isExpanded && this.readMoreButton(isExpanded)}
      </div>
    );
  }
}

export default AssessmentCriteria;



// WEBPACK FOOTER //
// ./src/components/assessments/assessment-criteria.jsx